<template>
  <v-dialog
    v-model="showGetAppDialog"
    scrollable
    :width="$vuetify.display.xs || $vuetify.display.sm ? '100vw' : '55vw'"
    @click:outside="decline"
  >
    <v-card
      ><v-col>
        <v-row justify="space-between" class="pa-4">
          <p class="bold-h1">Ladda ner vår app</p>
          <v-btn @click="decline" icon="mdi-close" elevation="0"></v-btn
        ></v-row>
        <v-row class="pr-5 pl-5">
          <v-col cols="6">
            <p class="body-2 pt-0">
              Ladda ner vår app för att enkelt hålla koll på dina beställningar,
              följa dem i realtid och få uppdateringar direkt på mobilen – allt
              för att göra din upplevelse ännu smidigare.
            </p>
            <v-row class="mt-4">
              <v-col cols="6">
                <v-img
                  height="160"
                  :src="qrCode_blue"
                  contain
                  alt="star-icon"
                ></v-img
              ></v-col>
              <v-col cols="6" align="center" justify="center">
                <v-img
                  class="hover"
                  @click="
                    goToWebsite(
                      'https://play.google.com/store/apps/details?id=com.nearbystore.Nearbystore&hl=sv'
                    )
                  "
                  height="80"
                  :src="getonGoogle"
                  contain
                  alt="star-icon"
                ></v-img>
                <v-img
                  class="hover"
                  @click="
                    goToWebsite(
                      'https://apps.apple.com/se/app/nearbystore/id1593224780'
                    )
                  "
                  height="80"
                  :src="getAppstore"
                  contain
                  alt="star-icon"
                ></v-img
              ></v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="mt-0">
            <v-img
              height="350"
              :src="getApp"
              contain
              alt="star-icon"
            ></v-img></v-col
        ></v-row> </v-col
    ></v-card>
  </v-dialog>
</template>
<script>
import getApp from "../assets/images/getApp.png";
import getApp2 from "../assets/images/getApp2.png";
import getonGoogle from "../assets/images/getonGoogle.png";
import getAppstore from "../assets/images/getAppstore.png";
import qrCode_blue from "../assets/images/qrCode_blue.png";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "DownloadApp",
  data() {
    return {
      getApp: getApp,
      getonGoogle: getonGoogle,
      getAppstore: getAppstore,
      getApp2: getApp2,
      qrCode_blue: qrCode_blue,
    };
  },
  props: ["visible"],

  computed: {
    ...mapState(["showGetAppDialog", "categories", "order", "user"]),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    isLoading() {
      return this.isGoogleLoading || this.isAppleLoading;
    },
  },
  methods: {
    ...mapActions([
      "toggleLocationModal",
      "setCategoryModal",
      "toggleCartModal",
      "userLoggedOut",
      "toggleshowGetAppDialog",
    ]),
    openModal() {
      console.log("TEST");
      this.show = true;
    },
    goToWebsite(url) {
      window.open(url, "_blank");
    },
    decline() {
      this.toggleshowGetAppDialog();
    },
  },
};
</script>
<style>
.hover {
  cursor: pointer;
}
</style>
